/* eslint-disable quotes */
export default {
  dashboard: {
    title: "لوحة معلومات مراقبة صحة الحيوان الجغرافية المكانية",
    zones: "المناطق",
    registration: "التسجيلات",
    localisedRegistration: "التسجيلات الممركزة جغرافيا",
    refresh: "تحديث",
    streetView: "عرض الشارع",
    satelliteView: "عرض القمر الصناعي",
    rechercherRegistrationRef: "ابحث عن تسجيل بالمرجع",
    barChartTitle: "عدد الأنواع المصابة حسب نوع المرض",
    lineChartTitle: "تطور الأمراض الحيوانية الرئيسية",
    mapTitle: "الموقع الجغرافي للبؤر الوبائية المبلغ عنها",
    pieChartTitle: "توزيع الحيوانات المريضة حسب النوع",
    boxCardTitle: "توزيع الحيوانات المريضة حسب السلالة",
    copyRight: "© 2025 كيلا دوزون. جميع الحقوق محفوظة.",
    sickAnimals: "الحيوانات المريضة",
    selectSpecie: "اختر نوعًا",
    selectYear: "اختر سنة",
    years: "السنوات",
    months: {
      1: "يناير",
      2: "فبراير",
      3: "مارس",
      4: "أبريل",
      5: "مايو",
      6: "يونيو",
      7: "يوليو",
      8: "أغسطس",
      9: "سبتمبر",
      10: "أكتوبر",
      11: "نوفمبر",
      12: "ديسمبر",
    },
  },
  general: {
    close: "إغلاق",
    description: "الوصف",
    code: "الرمز",
    nom: "الاسم",
    libelle: "التسمية",
    title: "العنوان",
    type: "النوع",
    search: "بحث",
    add: "إضافة",
    export: "تصدير",
    id: "المعرف",
    date: "التاريخ",
    author: "المؤلف",
    status: "الحالة",
    actions: "الإجراءات",
    edit: "تعديل",
    delete: "حذف",
    cancel: "إلغاء",
    confirm: "تأكيد",
    keyword: "الكلمات المفتاحية",
    role: "الدور",
    permissions: "الصلاحيات",
    menus: "القوائم",
    rolesEtpermissions: "الأدوار والصلاحيات",
    deleteWarningText: "هل أنت متأكد أنك تريد الحذف؟",
    deleteConfirmButtonText: "نعم، احذف",
    deleteCancelButtonText: "لا، اترك",
    save: "حفظ",
    saving: "جارٍ الحفظ...",
    closingWarningText: "هل أنت متأكد أنك تريد الإغلاق؟",
    notFound: "لا توجد عناصر",
    actives: "مفعلة",
    visible: "مرئي",
    disponibles: "متاحة",
    M_actives: "مفعل",
    F_actives: "مفعلة",
    M_desactives: "معطل",
    F_desactives: "معطلة",
    M_supprimes: "محذوف",
    F_supprimes: "محذوفة",
    corbeille: "سلة المحذوفات",
    restaurer: "استعادة",
    suppressionDefinitive: "حذف نهائي",
    nonActives: "غير مفعلة",
    nonVisibles: "غير مرئية",
    F_actif: "نشطة",
    M_actif: "نشط",
    deleteContinue: "متابعة؟",
    suppressionAnnule: "تم إلغاء الحذف",
    filter: "تصفية",
    init: "إعادة التهيئة",
    statusUpdated: "تم تحديث الحالة بنجاح!",
    statusUpdateError: "عذرًا، حدث خطأ أثناء تحديث الحالة",
    ouiSupprimer: "نعم، احذف",
    irrversibleMessage: "هذا الإجراء لا رجعة فيه",
    SureQuestion: "هل أنت متأكد؟",
    periode: "الفترة",
    startDateplaceholder: "تاريخ البداية",
    endDateplaceholder: "تاريخ النهاية",
    DaterangeSeparator: "إلى",
    ImapeUploadFieldText: "اضغط للإرسال",
    clotures: "مغلقة",
    labelColonneCloturer: "مغلقة",
    allpermissions: "جميع الصلاحيات",
    formInvalid: "النموذج غير صالح! يرجى التحقق من البيانات!",
    admins: "المدراء",
    donors: "المتبرعون",
    recipients: "المستفيدون",
    others: "آخرون",
    processing: "جارٍ المعالجة",
    success: "تم بنجاح",
    error: "خطأ",
    disabled: "معطل",
    enabled: "مفعل",
    details: "تفاصيل",
    yes: "نعم",
    no: "لا",
    paredExchange: "تبادل مقترن",
    guest: "الضيوف",
    editors: "المحررون",
    othersUsers: "مستخدمون آخرون",
    users: "المستخدمون",
    publish: "نشر",
    SaveDraft: "حفظ كمسودة",
    envoiEncours: "جارٍ الإرسال...",
    envoyer: "إرسال",
    sendGeneralNotification: "إشعار للجميع",
    invalidForm: "يرجى إعادة التحقق من المعلومات المدخلة",
    accountIsActive: "حسابك نشط!",
    accountIsActiveDetails:
      "حسابك نشط، يرجى تحميل تطبيق جيوصحة من متجر AppStore و PlayStore للوصول إلى حسابك",
    reference: "المرجع",
    unknown: "غير معروف",
    noData: "لا توجد بيانات",
    import: "استيراد",
  },
  route: {
    dashboard: "الرئيسية",
    introduction: "مقدمة",
    documentation: "التوثيق",
    guide: "دليل",
    permission: "الصلاحية",
    pagePermission: "صفحة الصلاحية",
    rolePermission: "الدور والصلاحية",
    icons: "الأيقونات",
    components: "المكونات",
    componentIndex: "مقدمة",
    errorPages: "صفحات الخطأ",
    page401: "401",
    page404: "404",
    errorLog: "السجلات",
    administration: "الإدارة",
    users: "المستخدمون",
    userProfile: "الملف الشخصي",
    regions: "المناطق",
    parcelles: "القطع",
    campagneagricoles: "الحملات الزراعية",
    species: "الأنواع",
    diseases: "الأمراض",
    provinces: "المحافظات",
    departments: "الأقسام",
    municipalities: "البلديات",
    villages: "القرى",
    breeds: "السلالات",
    localites: "المحليات",
    registrations: "التسجيلات",
    reports: "التقارير",
    subscriptions: "الأعضاء",
    articles: "المقالات",
    tags: "الوسوم",
    categoriestags: "التصنيفات والوسوم",
    editArticle: "تعديل المقال",
    discussions: "المناقشات",
    UserProfile: "الملف الشخصي",
    comments: "التعليقات",
    locations: "المواقع",
    animals: "الحيوانات",
  },
  navbar: {
    logOut: "تسجيل الخروج",
    dashboard: "الرئيسية",
    github: "Github",
    theme: "الثيم",
    size: "الحجم العام",
    profile: "الملف الشخصي",
  },
  login: {
    title: "تسجيل الدخول",
    logIn: "تسجيل",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    email: "البريد الإلكتروني",
    correctEmail: "أدخل بريدًا إلكترونيًا صحيحًا",
    shortPassword: "كلمة المرور قصيرة جدًا (الحد الأدنى 6 أحرف)",
    emailOrUsername: "اسم المستخدم أو البريد",
    emailOrUsernameRequired: "يرجى إدخال اسم المستخدم أو البريد الإلكتروني",
  },
  passwordreset: {
    enterCode: "أدخل الرمز المرسل بالبريد",
    checkCode: "تحقق",
    token: "الرمز",
    forgotPassword: "نسيت كلمة المرور",
    resendcode: "إعادة إرسال الرمز",
    enterEmail: "أدخل بريدك الإلكتروني",
    sendcode: "إرسال الرمز",
    setYourPassword: "قم بتعيين كلمة مرور جديدة",
    confirmPassword: "تأكيد كلمة المرور",
    password: "أدخل كلمة المرور",
    savepassword: "حفظ",
    ConfirmPasswordRequired: "يرجى تأكيد كلمة المرور",
    codeIsRequired: "يرجى إدخال الرمز",
    successEnd: "تم تغيير كلمة المرور بنجاح!",
    successEndDetails:
      "لقد غيرت كلمة المرور الخاصة بك بنجاح! يمكنك الآن تسجيل الدخول بكلمة مرورك الجديدة",
    codeIsValid: "الرمز صالح! يرجى إدخال كلمة مرور جديدة",
    codeSent: "تم إرسال رمز إلى بريدك الإلكتروني، يرجى التحقق",
  },
  permission: {
    addRole: "دور جديد",
    editPermission: "تعديل الصلاحية",
    editPermissions: "تعديل الصلاحيات",
    roles: "الأدوار",
    switchRoles: "تفعيل الأدوار",
    delete: "حذف",
    confirm: "تأكيد",
    cancel: "إلغاء",
    permissionsUpdated: "تم تحديث الصلاحيات بنجاح!",
    extraPermissions: "صلاحيات إضافية",
    addedPermissions: "صلاحيات مضافة",
    noSelectionAdd: "لم تتم إضافة صلاحية",
    manage: "إدارة الصلاحيات",
    addPermissions: "إضافة صلاحيات",
    tableName: "اسم الجدول",
    NameRequired: "يرجى إدخال الاسم",
    iscreatedSuccessfully: "تمت إضافة الصلاحية بنجاح",
    name: "الصلاحية",
    suppressionEffectue: "تم حذف الصلاحية بنجاح",
  },
  excel: {
    export: "تصدير",
    selectedExport: "تصدير العناصر المحددة",
    placeholder: "أدخل اسم الملف (افتراضي: liste-excel)",
  },
  theme: {
    change: "تغيير الثيم",
    documentation: "توثيق الثيم",
    tips: "ملاحظة: يختلف عن اختيار الثيم من شريط التنقل، فهما طريقتان مختلفتان للتخصيص ولكل سيناريو خاص به.",
  },
  settings: {
    title: "إعدادات نمط الصفحة",
    theme: "لون الثيم",
    tagsView: "إظهار الوسوم",
    fixedHeader: "تثبيت الرأس",
    sidebarLogo: "الشعار",
  },
  tagsView: {
    refresh: "تحديث",
    close: "إغلاق",
    closeOthers: "إغلاق الآخرين",
    closeAll: "إغلاق الكل",
  },
  user: {
    name: "الاسم",
    user: "المستخدم",
    role: "الدور",
    password: "كلمة المرور",
    c_password: "تأكيد كلمة المرور",
    nom: "الاسم",
    prenom: "اللقب",
    email: "البريد الإلكتروني",
    username: "اسم المستخدم",
    code: "الرمز",
    EditPermissions: "تعديل الصلاحيات",
    AddUser: "إضافة مستخدم",
    selectRole: "اختر دورًا",
    PasswordsInconform: "كلمات المرور غير متطابقة",
    RoleRequired: "يرجى اختيار دور",
    NomRequired: "يرجى إدخال الاسم",
    EmailRequired: "يرجى إدخال البريد الإلكتروني",
    EmailInvalide: "يرجى إدخال بريد إلكتروني صالح",
    PasswordRequired: "يرجى إدخال كلمة المرور",
    deleteWarn: "سيتم حذف المستخدم",
    deleteContinue: "متابعة؟",
    cancel: "إلغاء",
    suppressionEffectue: "تم الحذف بنجاح!",
    suppressionAnnule: "تم إلغاء الحذف",
    NewUser: "مستخدم جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    PermissionsUpdated: "تم تحديث الصلاحيات بنجاح!",
    users: "المستخدمون",
    edit: "تعديل المستخدم",
    PasswordMin6: "يجب أن تكون 6 أحرف على الأقل",
    isupdatedSuccessfully: "تم تحديث المستخدم بنجاح!",
    changeCredentils: "تغيير كلمة المرور",
    nochangeCredentils: "لا تغير كلمة المرور",
    changeAvatar: "تغيير الصورة الرمزية",
    account: "الحساب",
    enterPassword: "أدخل كلمة المرور للمتابعة",
    profileUpdated: "تم تحديث ملفك الشخصي بنجاح!",
    willAddPassword: "سيضيف المستخدم كلمة مروره",
    willAddPasswordMessage:
      "سيتم إرسال بريد إلكتروني للمستخدم يحتوي على رابط لتعيين كلمة المرور",
  },
  message: {
    message: "رسالة",
    messages: "الرسائل",
    subject: "الموضوع",
    description: "الوصف",
    subjectRequired: "أدخل الموضوع",
    messageRequired: "أدخل الرسالة",
    deleteWarn: "سيتم حذف الرسالة",
    suppressionEffectue: "تم حذف الرسالة بنجاح",
    NewCategorie: "رسالة جديدة",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    sentMessage: "تم إرسال رسالتك بنجاح",
    isupdatedSuccessfully: "تم تحديث الرسالة بنجاح",
    created_at: "تم الإنشاء في",
    edit: "تعديل الرسالة",
    AddCategorie: "رسالة جديدة",
    sendTo: "إرسال إلى",
  },
  roles: {
    deleteWarn: "تحذير: سيتم حذف الدور",
    permissions: "الصلاحيات",
    nom: "اسم الدور",
    users: "المستخدمون",
    extraMenus: "قوائم إضافية",
    InheritedfromRole: "موروث من دور آخر",
    addRole: "إضافة دور",
    name: "الدور",
    NewRole: "دور جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح!",
    isupdatedSuccessfully: "تم تحديث الدور بنجاح",
    NameRequired: "يرجى إدخال اسم الدور",
    edit: "تعديل الدور",
    suppressionEffectue: "تم حذف الدور بنجاح",
    description: {
      admin: "المسؤول الأعلى الذي يدير التطبيق",
      manager: "المدير هو المشرف على التطبيق",
      editeur: "مستخدم يمكنه إدخال البيانات",
      utilisateur: "مستخدم عادي",
      visiteur: "الزوار لديهم حق العرض فقط",
    },
  },
  specie: {
    specie: "النوع",
    species: "الأنواع",
    name: "الاسم",
    body: "الوصف",
    NameRequired: "يرجى إدخال اسم النوع",
    deleteWarn: "سيتم حذف النوع",
    suppressionEffectue: "تم حذف النوع بنجاح",
    NewSpecie: "نوع جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث النوع بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل النوع",
    AddSpecie: "نوع جديد",
    selectSpecieTitle: "اختر النوع",
    specieRequired: "يرجى اختيار نوع",
  },
  province: {
    province: "المحافظة",
    provinces: "المحافظات",
    reference: "المرجع",
    code: "الرمز",
    name: "الاسم",
    NameRequired: "يرجى إدخال اسم المحافظة",
    deleteWarn: "سيتم حذف المحافظة",
    suppressionEffectue: "تم حذف المحافظة بنجاح",
    NewProvince: "محافظة جديدة",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث المحافظة بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل المحافظة",
    AddProvince: "محافظة جديدة",
    selectProvinceTitle: "اختر المحافظة",
    provinceRequired: "يرجى اختيار محافظة",
  },
  department: {
    department: "القسم",
    departments: "الأقسام",
    name: "الاسم",
    NameRequired: "يرجى إدخال اسم القسم",
    deleteWarn: "سيتم حذف القسم",
    suppressionEffectue: "تم حذف القسم بنجاح",
    NewDepartment: "قسم جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث القسم بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل القسم",
    AddDepartment: "قسم جديد",
    selectDepartmentTitle: "اختر القسم",
    departmentRequired: "يرجى اختيار قسم",
  },
  municipality: {
    municipality: "البلدية",
    municipalities: "البلديات",
    name: "الاسم",
    NameRequired: "يرجى إدخال اسم البلدية",
    deleteWarn: "سيتم حذف البلدية",
    suppressionEffectue: "تم حذف البلدية بنجاح",
    NewMunicipalitie: "بلدية جديدة",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث البلدية بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل البلدية",
    AddMunicipalitie: "بلدية جديدة",
    selectMunicipalityTitle: "اختر البلدية",
    municipalityRequired: "يرجى اختيار بلدية",
  },
  village: {
    village: "القرية",
    villages: "القرى",
    name: "الاسم",
    NameRequired: "يرجى إدخال اسم القرية",
    deleteWarn: "سيتم حذف القرية",
    suppressionEffectue: "تم حذف القرية بنجاح",
    NewVillage: "قرية جديدة",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث القرية بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل القرية",
    AddVillage: "قرية جديدة",
    selectVillageTitle: "اختر القرية",
    villageRequired: "يرجى اختيار قرية",
  },
  registration: {
    registration: "التسجيل",
    registrations: "التسجيلات",
    ref: "المرجع",
    maleNumber: "الذكور",
    femaleNumber: "الإناث",
    status: "الحالة",
    coordinates: "الإحداثيات",
    NameRequired: "يرجى إدخال اسم التسجيل",
    deleteWarn: "سيتم حذف التسجيل",
    suppressionEffectue: "تم حذف التسجيل بنجاح",
    NewRegistration: "تسجيل جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث التسجيل بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل التسجيل",
    AddRegistration: "تسجيل جديد",
    selectRegistrationTitle: "اختر التسجيل",
  },
  breed: {
    breed: "السلالة",
    breeds: "السلالات",
    name: "الاسم",
    description: "الوصف",
    NameRequired: "يرجى إدخال اسم السلالة",
    deleteWarn: "سيتم حذف السلالة",
    suppressionEffectue: "تم حذف السلالة بنجاح",
    NewBreed: "سلالة جديدة",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث السلالة بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل السلالة",
    AddBreed: "سلالة جديدة",
    selectBreedTitle: "اختر السلالة",
  },
  disease: {
    disease: "المرض",
    diseases: "الأمراض",
    name: "الاسم",
    body: "الوصف",
    NameRequired: "يرجى إدخال اسم المرض",
    deleteWarn: "سيتم حذف المرض",
    suppressionEffectue: "تم حذف المرض بنجاح",
    NewDisease: "مرض جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث المرض بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل المرض",
    AddDisease: "مرض جديد",
    selectDiseaseTitle: "اختر المرض",
    diseaseRequired: "يرجى اختيار مرض",
    selectDiseasesTitle: "اختر الأمراض",
    diseasesRequired: "يرجى اختيار الأمراض",
  },
  subscription: {
    subscription: "الاشتراك",
    subscriptions: "الأعضاء",
    organ: "العضو",
    story: "القصة",
    age: "العمر",
    height: "الطول",
    weight: "الوزن",
    gender: "الجنس",
    zip_code: "الرمز البريدي",
    type: "النوع",
    travel: "السفر",
    travel_no: "لا يمكنه السفر",
    travel_yes: "يمكنه السفر",
    blod_type: "فصيلة الدم",
    OrganRequired: "يرجى اختيار عضو",
    BodyRequired: "أخبرنا المزيد عنك!",
    deleteWarn: "سيتم حذف الاشتراك",
    suppressionEffectue: "تم حذف الاشتراك بنجاح",
    NewSubscription: "اشتراك جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث الاشتراك بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل الاشتراك",
    AddSubscription: "اشتراك جديد",
    UserRequired: "يجب اختيار مستخدم",
    selectSubscriptionTitle: "اختر اشتراكًا",
    noSubscription: "غير مشترك",
    paired: "مقترن",
  },
  report: {
    reported: "تم التبليغ",
    report: "تقرير",
    reports: "التقارير",
    subject: "الموضوع",
    reasons: "الوصف",
    SubjectRequired: "يرجى إدخال موضوع التقرير",
    BodyRequired: "يرجى تزويدنا بمزيد من التفاصيل!",
    deleteWarn: "سيتم حذف التقرير",
    suppressionEffectue: "تم حذف التقرير بنجاح",
    NewReport: "تقرير جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث التقرير بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل التقرير",
    AddReport: "تقرير جديد",
    UserRequired: "يجب اختيار مستخدم",
    selectReportTitle: "اختر التقرير",
    processing: "قيد المعالجة",
    guest: "الضيوف",
  },
  discussion: {
    discussion: "المناقشة",
    discussions: "المناقشات",
    sender: "المرسل",
    with: "مع",
  },
  article: {
    reported: "تم التبليغ",
    report: "تقرير",
    articles: "المقالات",
    title: "العنوان",
    content: "المحتوى",
    TitleRequired: "يرجى إدخال عنوان المقال",
    contentRequired: "يرجى كتابة مقالك!",
    deleteWarn: "سيتم حذف المقال",
    suppressionEffectue: "تم حذف المقال بنجاح",
    NewArticle: "مقال جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث المقال بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل المقال",
    addTitle: "أدخل عنوان المقال",
    CategorieRequired: "يجب اختيار تصنيف",
    selectCategorieTitle: "اختر التصنيف",
    addTitleandImageMessage:
      "يرجى إدخال عنوان المقال وإضافة الصورة الافتراضية",
    addSummary: "إضافة ملخص",
    addSummaryMessage:
      "أضف وصفًا قصيرًا يمكن أن يكون ملخصًا لمقالك. حدد الأهمية لترتيب المقالات",
    addCategory: "اختر تصنيفًا",
    addCategoryMessage:
      "يرجى اختيار تصنيف، وحدد ما إذا كانت التعليقات مفتوحة أم مغلقة لهذا المقال",
    addTag: "أضف وسومًا! متى تريد النشر؟",
    addTagMessage:
      "هنا يمكنك تحديد وقت النشر، كما يمكنك إضافة وسوم. اختر الوسوم أو أنشئ وسومًا جديدة!",
    SummaryRequired: "يجب إدخال ملخص",
    CategoryRequired: "يجب اختيار تصنيف",
    Addarticle: "مقال جديد",
    approuvePost: "الموافقة على المقال",
    approuvePostMessage: "هل أنت متأكد أنك تريد نشر هذا المقال؟",
    yesPublish: "نعم، انشر",
    postDetails: "تفاصيل المقال",
  },
  comment: {
    comment: "تعليق",
    comments: "التعليقات",
    postTitle: "المقال",
    deleteWarn: "سيتم حذف التعليق",
    suppressionEffectue: "تم حذف التعليق بنجاح",
    created_at: "تم الإنشاء في",
    edit: "تعديل التعليق",
  },
  localite: {
    localites: "المحليات",
    AddLocalite: "محلية جديدة",
    nolocalite: "للبدء، اضغط على الزر (+) وأضف محلية",
  },
  categorie: {
    categorie: "التصنيف",
    categories: "التصنيفات",
    label: "الوسم",
    description: "الوصف",
    labelRequired: "يرجى إدخال اسم التصنيف",
    descriptionRequired: "يرجى إدخال وصف قصير",
    deleteWarn: "سيتم حذف التصنيف",
    suppressionEffectue: "تم حذف التصنيف بنجاح",
    NewCategorie: "تصنيف جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث التصنيف بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل التصنيف",
    AddCategorie: "تصنيف جديد",
    CategorieRequired: "يجب اختيار تصنيف",
    selectCategorieTitle: "اختر تصنيفًا",
    articleCount: "المقالات",
  },
  tag: {
    tag: "الوسم",
    tags: "الوسوم",
    label: "الوسم",
    description: "الوصف",
    labelRequired: "يرجى إدخال الوسم",
    deleteWarn: "سيتم حذف الوسم",
    suppressionEffectue: "تم حذف الوسم بنجاح",
    NewTag: "وسم جديد",
    iscreatedSuccessfully: "تم الإنشاء بنجاح",
    isupdatedSuccessfully: "تم تحديث الوسم بنجاح!",
    created_at: "تم الإنشاء في",
    edit: "تعديل الوسم",
    AddTag: "وسم جديد",
    selectTagTitle: "أضف وسومًا",
  },
};
/* eslint-enable quotes */
